<div class="wrap">
    <text [content]="component"></text>
</div>
<div class="left p-t-6 _drag-container wrap no-wrap"
     style="padding-right: 0px !important; padding-left: 0px !important;"
     dragScroll>
    @for (item of component.links; track $index) {
    <div class="inline-flex flex-middle va-t p-a-2 p-l-3 p-r-3  _drag-item b-radius-4"
         [ngClass]="component.darkLinkBg ? 'bg-col-51' : 'bg-col-w'"
         [class.m-r-3]="!$last"
         [class._last]="$last"
         [class._first]="$first">
        <href [link]="item.url">
            <div class="flex flex-middle">
                @if(item.image) {
                <div class="_img pos-relative overflow-hidden b-radius-max m-r-2">
                    <shell />
                    <img draggable="false"
                         class="_drag-item pos-relative"
                         [ratio]="1"
                         [width]="44"
                         [dfImage]="item.image">
                </div>
                }
                <div class="s2 center overflow-hidden"
                     *iCms="'text' of item">
                </div>
            </div>
        </href>
    </div>
    }
</div>
